var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from "react";
import { PalletPatternIcon } from "./pallet-pattern-icon";
import { getBoxWorldFootprint, getCardboardBoxWorldFootprint } from "3d/pallet";
import { DEFAULT_LAYER } from "store/layers";
import { palletLayoutToBoxes } from "store/scene/pallet-layout";
/*
 * A top view of a saved (or about to be saved) layer, drawn like a preset but
 * on the pallet and box size it was arranged for rather than the current ones.
 */
export var PalletLayoutIcon = function (_a) {
    var layout = _a.layout, width = _a.width;
    var placements = useMemo(function () {
        return palletLayoutToBoxes(layout, DEFAULT_LAYER).map(function (box) { return (__assign(__assign({}, box), { footprint: getCardboardBoxWorldFootprint(box, layout.boxSize) })); });
    }, [layout]);
    var boxFootprint = useMemo(function () { return getBoxWorldFootprint(layout.boxSize); }, [layout.boxSize]);
    return (_jsx(PalletPatternIcon, { pallet: layout.pallet, boxFootprint: boxFootprint, placements: placements, width: width }));
};
